/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React from 'react';

import Icon, { IconTypes } from 'components/Icon';

import { MdOutlineRule as QuestionsIcon } from 'react-icons/md';

export default function SecureMethodIcon({ method, size, color }) {
  switch (method) {
    case 'SmsCode':
      return <Icon type={IconTypes.MobilePhone} color={color}
        size={size} />;
    case 'EmailCode':
      return <Icon type={IconTypes.Email} color={color}
        size={size} />;
    case 'SecurityQuestions':
      return <QuestionsIcon color={color}
        size={size} />;
    default: return null;
  }
}